import styled from "styled-components/macro"
import { mobile, tablet } from "../styles/responsive"
import { Link } from "react-router-dom"

export const Container = styled.div`
  display: flex;
  background-color: #e7ecf3;
  ${mobile({ flexDirection: "column" })}
`
export const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`
export const Logo = styled.h1``
export const Desc = styled.p`
  margin: 20px 0;
`
export const SocialContainer = styled.div`
  display: flex;
`
export const SocialIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  background-color: #4c87ef;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`
export const Center = styled.div`
  flex: 1;
  padding: 20px;
  ${mobile({ display: "none" })}
`
export const Title = styled.h3`
  margin-bottom: 30px;
`
export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`
export const ListItem = styled.li`
  margin-bottom: 10px;
  color: black;
  &:hover {
    color: #4c87ef;
  }
`
export const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`

export const Right = styled.div`
  flex: 1;
  padding: 20px;
  ${tablet({ padding: "0", paddingLeft: "10px" })}
`
export const ContactItem = styled.p`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  display: inline-block;
  word-break: break-word;
`
